import { cn } from "../../utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("al-animate-pulse al-rounded-md al-bg-muted", className)} {...props} />;
}

export { Skeleton };
